import {EssenceAchat} from '@/models';

export default [
	{
		path: '/essenceAchats',
		name: 'essenceAchats',
		meta: {
			title: 'Liste des essences achetées',
			granted: [ 'API_GET_ESSENCEACHAT' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EssenceAchat.vue')
	},
	{
		path: '/essenceAchats/edit/:id',
		name: 'essenceAchat-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/EssenceAchat/Edit.vue'),
				class: EssenceAchat
			}),
		},
		meta: {
			title: 'Edition d\'un essenceAchat',
			granted: [ 'API_PUT_ESSENCEACHAT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
